<template>
  <div class="candidat">
    <div v-if="!loading">
      <div  v-if="currentUser.role && currentUser.role.toLowerCase() == 'startup'" class="ml-4 font-bold text-xl text-red mb-3">{{ $t("ecosystem.startup_first_section") }}</div>
      <div v-if="session && session.application_session!=null || (currentUser.role == 'sso' && (this.ecosystemSession instanceof Object))">
        <div
          class="ml-4 font-bold text-gray mb-3"
          v-if="((session && session.application_session && session.application_session.status=='1' && session.application_session.first_step_status=='1')) 
          && currentUser.role.toLowerCase() != 'investor' && session.application_session != null && session.application_session.limit_date == false && session.application_session.first_step_limit_date == false"
        >{{$t('candidat.session_with_submit')}}</div>
        <div
          class="ml-4 font-bold text-gray mb-3"
          v-if="((session && session.application_session && session.application_session.status == '1')) 
          && currentUser.role.toLowerCase() != 'investor' && session.application_session != null && session.application_session.limit_date == false 
          && (session.application_session.first_step_limit_date == true || session.application_session.first_step_status != '1')"
          >{{$t('candidat.session_without_submit')}}
        </div>
        <div
          class="ml-4 font-bold text-gray mb-3"
          v-if="session.application_session != null && session.application_session.status != '1' 
                || session.application_session != null && session.application_session.limit_date == true
                || session.application_session != null && session.application_session.status == '1' && session.application_session.limit_date == true"
          >{{$t('candidat.cant_deposit')}}
        </div>
        <div
          class="ml-4 font-bold text-md text-blue mb-3"
          v-if="((session && session.application_session && session.application_session.first_step_status=='1') || (currentUser.role == 'sso' && ecosystemSession && ecosystemSession['Certif'] && ecosystemSession['Certif'].first_step_status == '1')) && currentUser.role.toLowerCase() != 'investor'"
          v-html="currentUser.role != 'sso' ? this.session.application_session.comment : ecosystemSession['Certif'].comment"
        ></div>

        <div></div>
      </div>
      <!-- <div v-if="(session && session.application_session && session.application_session.first_step_status!='1' 
      || (currentUser.role != 'sso' && session && !session.application_session))">
        <div class="ml-4 font-bold text-xl text-red mb-3">{{ $t("candidat.no_session_send") }}</div>
        <div class="ml-4 font-bold text-md text-blue mb-3">{{ $t("candidat.can_send_candidat") }}</div>
      </div>
      <div v-if="(session && session.application_session 
      && session.application_session.first_step_status =='1'
      && session.application_session.status =='1'
      && session.application_session.max_apps == true)"
      >
        <div class="ml-4 font-bold text-md text-blue mb-3">
          {{session.application_session.limit_date == true ? 'La date limite' : 'Le nombre maximal de candidatures'}} pour cette session est atteint, merci de soumettre votre candidature lors de la session prochaine.
        </div>
      </div> -->
    </div>
    <!-- START SSO  -->
    <div v-if="currentUser.role == 'sso'">
      <div v-if="ecosystemApps.sessions.Certif == null || ecosystemApps.sessions.Certif.first_step_status == '0'" class="ml-4 font-bold text-xl text-red mb-3">{{ $t("candidat.no_session_send") }}</div>
      <grid v-if="ecosystemApps.applications" :data="ecosystemApps.applications" :types="['Certif', 'Deal', 'Sail']"></grid>
    </div>
    <!-- END SSO -->

    <div class="flex flex-wrap mb-6 text-center" v-else-if="exist_app == true && show_list_app == true && currentUser.role == 'Startup'">
      <div
        class="md:w-1/2 lg:w-1/3 w-full my-4"
        v-for="(apps,index) in listApplications"
        v-bind:key="index"
      >
        <div
          class="box-application relative rounded shadow-lg p-4 font-bold text-blue hover:opacity-75 h-full text-center mx-4"
        >
          <h3
            class="mb-6 text-base text-center ecosystem-application-title"
            v-if="apps.type"
          >{{apps.type == 'Label' ? 'Innovation' : (apps.type == 'Digital' ? 'Digitalisation' : (apps.type == 'Prélabel' ? 'Durabilité environementale' : apps.type))}}</h3>
          <h3 class="mb-6 text-base text-center ecosystem-application-title" v-else>NULL</h3>
          
          <div class="text-2sm flex">
            <div class="text-sm mr-6">
              <div class="mb-2">
                <span class="opacity-50">Status:</span>
              </div>
              <span v-if="apps.status == 0">{{$t('candidat.being_entered')}}</span>
              <span
                v-if="(apps.status != 0 && apps.show_result == false) || apps.status == 1 || apps.status == 2 || apps.status == 4 || apps.status == 5"
              >{{$t('candidat.submitted_instruction')}}</span>
              <span v-if="apps.status != 0 && apps.show_result == true">
                <span
                  v-if="apps.status == 3 || apps.status == 6 || apps.status == 8 || apps.status == 10"
                >{{$t('candidat.Refused')}}</span>
                <span
                  v-if="apps.status == 9 && apps.show_result == true"
                >{{$t('candidat.candidature_accepted')}}</span>
               
                <span v-if="apps.status == 11 ">{{$t('candidat.Awaiting_further_information')}}</span>
                <span v-if="apps.status == 12">{{$t('candidat.invalid_label')}}</span>
              </span>
            </div>
            <div class="text-sm">
              <div class="mb-2">
                <span class="opacity-50">Type:</span>
              </div>
              <span class="font-bold">{{apps.type == 'Label' ? 'Innovation' : (apps.type == 'Digital' ? 'Digitalisation' : (apps.type == 'Prélabel' ? 'Durabilité environementale' : apps.type))}}</span>
            </div>
          </div>

          <div class="p-4 text-center">
            <sp-button
              v-if="['1','2', '7', '9', '4', '5', '3','6','8','10','12'].includes(apps.status)"
              @click="visibleEditApplication(apps)"
              class="bg-red hover:bg-red text-white font-bold py-2 px-4 rounded inline-flex items-center"
            >
              <span v-if="session.user_auth.id == apps.user_id">{{ $t('candidat.show_candidat') }}</span>
              <span v-else>{{ $t('candidat.show_member_candidat') }}</span>
            </sp-button>
            <sp-button
              v-if="apps.status == 0 || apps.status == 11"
              class="bg-red hover:bg-red text-white font-bold py-2 px-4 rounded inline-flex items-center"
            >
              <img
                class="fill-current w-4 h-4 mr-2"
                src="../assets/img/cand/pencil-write.svg"
                alt="startup act action"
              />
              <span
                v-if="session.user_auth.id == apps.user_id"
                @click="showEditCandidat(apps.hash_id)"
              >{{ $t('candidat.edit_candidat') }}</span>
              <span
                v-else
                @click="showEditCandidatMemebre(apps.hash_id)"
              >{{ $t('candidat.edit_member_candidat') }}</span>
            </sp-button>
          </div>
          <div v-if="apps.status == 0" class="px-6 text-center h-5">
            <sp-button
              v-if="session.user_auth.id == apps.user_id"
              class="text-grey"
              @click="showDelete(apps.hash_id)"
            >
              <span>{{ $t('candidat.delete') }}</span>
            </sp-button>
          </div>
        </div>
      </div>
      <div class="btn-add-app md:w-1/2 lg:w-1/3 w-full my-4" v-if="can_apply_app == true">
        <div
          class="box-info relative mx-4 p-4 rounded shadow-lg font-bold text-blue hover:opacity-75 h-full text-2sm flex items-center justify-center"
        >
          <div class="text-sm">
            <div class="mb-4 text-center">
              <button
                @click="visibleNewApplications()"
                v-scroll-to="'#section_candidat'"
                class="relative button bg-red hover:bg-red text-white font-bold"
              ></button>
            </div>
            <span class="inline-block text-center">{{$t("candidat.add_new_app")}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentUser.role && currentUser.role != 'form-builder' && currentUser.role.toLowerCase() != 'investor'">
      <loader v-if="exist_app == false && visible_add_candidate == false"></loader>
      <Candidat v-if="visible_add_candidate == true && currentUser.role != 'sso'"></Candidat>
    </div>
    <!-- START AIR-AIR2  -->
    <div v-if="currentUser && currentUser.role && currentUser.role.toLowerCase() == 'startup'">
      <!-- <div class="ml-4 font-bold text-xl text-red mb-3 mt-10">{{ $t("ecosystem.startup_second_section") }}</div>
      <div class="ml-4 font-bold text-md text-blue mb-3">{{ $t("ecosystem.funding_instrument_description") }} <a class="no-underline" href="https://flywheel.startup.gov.tn/startup/" target="_blank">https://flywheel.startup.gov.tn/startup/</a></div>
      <div v-if="ecosystemSession && ecosystemSession['Air']">
        <div v-if="(ecosystemSession['Air'].first_step_status=='1')">
          <div class="ml-4 font-bold text-gray mb-3">
            {{ $t("candidat.can_deposit") }}
          </div>
          <div class="ml-4 font-bold text-md text-blue mb-3" v-html="ecosystemSession['Air'].comment">
          </div>
        </div>
        <div v-else>
          <div class="ml-4 font-bold text-xl text-red mb-3">{{ $t("candidat.no_session_send") }}</div>
          <div class="ml-4 font-bold text-md text-blue mb-3">{{ $t("candidat.can_send_candidat") }}</div>
        </div>
      </div>
      <grid :seperatedApps="true" v-if="ecosystemApps.applications" :data="ecosystemApps.applications" :types="['Air','Air2']"></grid> -->
    </div>
    <!-- END AIR-AIR2 -->
    <!-- START D4D -->
    <!-- <div v-if="currentUser && currentUser.role && currentUser.role.toLowerCase() == 'startup'">
      <div class="ml-4 font-bold text-xl text-red mb-3 mt-10">{{ $t("ecosystem.startup_third_section") }}</div>
      <div class="ml-4 font-bold text-md text-blue mb-3">{{ $t("ecosystem.d4d_instrument_description") }}</div>
      <div v-if="ecosystemSession && ecosystemSession['D4D']">
        <div v-if="(ecosystemSession['D4D'].first_step_status=='1')">
          <div class="ml-4 font-bold text-gray mb-3">
            {{ $t("candidat.can_deposit") }}
          </div>
          <div class="ml-4 font-bold text-md text-blue mb-3" v-html="ecosystemSession['D4D'].comment">
          </div>
        </div>
        <div v-else>
          <div class="ml-4 font-bold text-xl text-red mb-3">{{ $t("candidat.no_session_send") }}</div>
          <div class="ml-4 font-bold text-md text-blue mb-3">{{ $t("candidat.can_send_candidat") }}</div>
        </div>
      </div>
      <grid :seperatedApps="true" v-if="ecosystemApps.applications" :data="ecosystemApps.applications" :types="['D4D']"></grid>
    </div> -->
    <!-- END D4D -->
    <!-- START INVESTOR -->
    <div v-if="currentUser && currentUser.role && currentUser.role.toLowerCase() == 'investor'">
      <div class="font-bold text-xl text-red mb-3 mt-10">{{ $t("ecosystem.investor_declaration") }}</div>
      <div>
      </div>
      <sessionless-grid :type="'investor'"></sessionless-grid>
    </div>
    <!-- END INVESTOR -->

    <modal
      name="remove-app"
      :adaptive="true"
      :resizable="true"
      :maxHeight="200"
      transition="nice-modal-fade"
    >
      <div class="mb-4 p-4 text-white bg-blue">
        <h3 class="font-bold text-xl text-white">{{ $t('candidat.confirmation') }}</h3>
      </div>
      <div class="mb-4 p-4 text-center">
        <p>{{ $t('candidat.msgDelete') }}</p>
      </div>
      <div class="flex justify-center p-2">
        <sp-button
          v-if="(session.startup_application!=null && session.startup_application.status ==0) || this.currentUser.role == 'sso' || (this.currentUser.role == 'Startup' && ecosystemSession)"
          theme="warning"
          size="normal"
          space="xsmall"
          @click="removeCandidate('remove-app')"
          :disabled="disabled"
        >
          <span>{{ $t('candidat.delete') }}</span>
        </sp-button>
        <sp-button
          v-if="(session.startup_application!=null && session.startup_application.status ==0) || this.currentUser.role == 'sso' || (this.currentUser.role == 'Startup' && ecosystemSession)"
          theme="grey"
          size="normal"
          space="xsmall"
          @click="hide('remove-app')"
          :disabled="disabled"
        >
          <span>{{ $t('candidat.cancel') }}</span>
        </sp-button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_APPLICATIONS,
  FETCH_APPLICATION,
  CHECK_APPLY_MULTIPLE_APPLICATION,
  FETCH_ECOSYSTEM_APPLICATIONS,
  CREATE_ECOSYSTEM_APP,
  DELETE_ECOSYSTEM_APP,
  FETCH_ECOSYSTEM_APPLICATION
} from "@/store/actions.type";
import {
  SET_ApplicationMenuActive,
  SET_LabelMenuActive,
  SET_HashId,
  SET_LabelApp,
  SET_HAS_APPS,
  SET_ECOSYSTEM_SESSION
} from "@/store/mutations.type";
import Button from "@/components/spKit/Button.vue";
import Candidat from "@/components/Candidat/candidat.vue";
import EcosystemApplication from "./Ecosystem/Application";
import Grid from "./Ecosystem/Grid";
import SessionlessGrid from "./SessionlessApplications/Grid";
import Loader from "@/components/Loader.vue"
import { Fragment } from "vue-fragment";

import Vue from "vue";
import VModal from "vue-js-modal";
import vueScrollto from "vue-scrollto";
Vue.use(VModal, {
  dialog: true
});

// ScrollToEnd
Vue.use(vueScrollto, {
  container: "body",
  duration: 2000,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

export default {
  name: "applications",
  components: {
    "sp-button": Button,
    Candidat: Candidat,
    Loader,
    'fragment': Fragment,
    'ecosystem-app': EcosystemApplication,
    'grid': Grid,
    'sessionless-grid' : SessionlessGrid
  },
  data() {
    return {
      type_app: "Label",
      type_choice: null,
      disabled: false,
      listApplications: [],
      exist_app: false,
      date_apply: "",
      can_apply_app: false,
      visible_add_candidate: false,
      user_id: "",
      show_list_app: false,
      ecosystemApps: [],
      test: [],
      loading: true
    };
  },
  modal: {
    visible: true
  },
  mounted() {
    if (this.currentUser.role != 'form-builder') {
      this.$store.commit(SET_LabelMenuActive, 0);
      this.$store.commit(SET_ApplicationMenuActive, 0);
      this.$store.commit(SET_HashId, null);
      this.$store.commit(SET_LabelApp, null);
    }
  },

  computed: {
    ...mapGetters([
      "session",
      "ApplicationMenuActive",
      "LabelMenuActive",
      "hashId",
      "LabelApplication",
      "currentUser",
      "ecosystemApp",
      "ecosystemSession"
    ])
  },

  watch: {
    currentUser() {
      if (this.currentUser.role == 'sso') {
        this.getEcosystemApplicationsList();
      } else {
        this.$store
          .dispatch(FETCH_APPLICATION)
          .then(data => {
            this.fetchApplications();
          })
          .catch(response => {
            this.can_apply_app = true;
            this.visible_add_candidate = true;
          });
          this.getEcosystemApplicationsList();
      }
    },
  },

  methods: {
    showDelete(id) {
      this.$store.commit(SET_HashId, id);
      this.$modal.show("remove-app");
    },
    showEditCandidat(id) {
      localStorage.setItem('ecosystem', false);
      this.$store.commit(SET_HashId, id);
      this.$store.commit(SET_ApplicationMenuActive, 1);
      this.$router.push({
        name: "FormCriteria",
        params: {
          app_id: id
        }
      });
    },
    showEditCandidatMemebre(id) {
      this.$store.commit(SET_HashId, id);
      this.$store.commit(SET_ApplicationMenuActive, 1);
      this.$router.push({
        name: "team-edit",
        params: {
          app_id: id,
          team_id: this.session.user_auth.id
        }
      });
    },
    hide(modal) {
      this.$modal.hide(modal);
    },
    removeCandidate(modal) {
        this.$store
          .dispatch(DELETE_ECOSYSTEM_APP, this.hashId)
          .then(() => {
            this.hide(modal);
            location.reload();
          });
    },
    // Visible Editable application add redirect if status egal to 9
    visibleEditApplication(app) {
      localStorage.setItem('ecosystem', false);
      this.$store.dispatch(FETCH_APPLICATION, app.hash_id).then(data => {
        if (app.show_result == true && app.status == 9) {
          if (app.show_label == true) {
            this.$store.commit(SET_LabelMenuActive, 1);
            this.$store.commit(SET_ApplicationMenuActive, 0);
            this.$store.commit(SET_HashId, app.hash_id);
            this.$router.push({
              name: "Label",
              params: {
                app_id: app.hash_id
              }
            });
            if (app.label_ref != null) {
              this.$store.commit(SET_LabelApp, app.label_ref);
            } else {
              this.$store.commit(SET_LabelApp, null);
            }
          } else {
            this.$store.commit(SET_ApplicationMenuActive, 1);
            this.visible_add_candidate = true;
            this.edit_app = true;
          }
        } else {
          this.$store.commit(SET_ApplicationMenuActive, 1);
          this.$store.commit(SET_LabelMenuActive, 0);
          this.$store.commit(SET_LabelApp, null);
          if (app.status == 0) {
            //this.visible_add_candidate = true;
            //this.edit_app = true;
          }
          else if (app.status == 12) {
            this.$store.commit(SET_LabelMenuActive, 1);
            this.$store.commit(SET_ApplicationMenuActive, 0);
            this.$store.commit(SET_HashId, app.hash_id);
            this.$router.push({
              name: "Label",
              params: {
                app_id: app.hash_id
              }
            });
          }
          else {
            this.$router.push({
              name: "Status",
              params: {
                app_id: app.hash_id
              }
            });
          }
        }
      });
    },
    // Visible Create a new application
    visibleNewApplications() {
      this.visible_add_candidate = true;
    },

    // Fetch List Applications
    fetchApplications() {
      this.$store
        .dispatch(FETCH_APPLICATIONS)
        .then(data => {
          this.listApplications = data.data.StartupApplications;
          this.exist_app = data.data.exist_app;
          if (this.exist_app == true) {
            // single application
            if (
              data.data.StartupApplications.length == 1 &&
              this.listApplications[0].show_result == false &&
              this.session.startup_application.user_id == this.session.user_auth.id
            ) {
              this.show_list_app = true;
              //Multiple Applications
            } else if (
              this.listApplications.length != 1 ||
              (this.listApplications.length == 1 &&
                this.listApplications[0].show_result == true) ||
              (this.listApplications.length == 1 &&
                this.session.startup_application.user_id !=
                  this.session.user_auth.id)
            ) {
              this.show_list_app = true;
              // Check Apply Multiple Applications
              this.$store
                .dispatch(
                  CHECK_APPLY_MULTIPLE_APPLICATION,
                  this.session.user_auth.id
                )
                .then(({ data }) => {
                  this.can_apply_app = data.apply_new_application.status;
                  this.date_apply = data.apply_new_application.date;
                });
            }
          } else {
            this.exist_app = false;
            this.visible_add_candidate = true;
            this.can_apply_app = true;
          }
          this.loading = false;
        })
        .catch(() => {
          this.listApplications = [];
        });
    },

    getEcosystemApplicationsList() {
      this.$store
        .dispatch(FETCH_ECOSYSTEM_APPLICATIONS, this.currentUser.id)
        .then(data => {
          if (this.currentUser && this.currentUser.role && this.currentUser.role == 'sso') {
            this.exist_app = true;
            this.visible_add_candidate = true;
          }
          if (data.hasOwnProperty('applications')) {
            this.ecosystemApps = data;
            this.$store.commit(SET_HAS_APPS, data.applications);
            this.$store.commit(SET_ECOSYSTEM_SESSION, data.sessions);
          }
        }).catch(response => {
          if (this.currentUser && this.currentUser.role && this.currentUser.role == 'sso') {
            this.exist_app = true;
            this.visible_add_candidate = true;
          }
        })
    },
  }
};
</script>

<style>
.box-application .application-title {
  border-bottom: 1px solid rgba(187, 196, 209, 0.46);
}
.btn-add-app button {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
.btn-add-app button::after {
  content: " ";
  position: absolute;
  display: block;
  background-color: #fff;
  height: 2px;
  top: 19px;
  left: 12px;
  z-index: 9;
  width: 16px;
}
.btn-add-app button::before {
  content: " ";
  position: absolute;
  display: block;
  background-color: #fff;
  width: 2px;
  left: 19px;
  top: 12px;
  z-index: 9;
  height: 16px;
}

.ecosystem-application-title {
  color: #FF4100
}

.lightgrey-background {
  background-color: #d3d3d3;
}

.p-25 {
  padding: .25rem;
}
</style>




